import { formatDate } from "@/utils/format-date";
import { JSX } from "react";

import { amountToneOf, formatAmount } from "../../utils/amount-display";
import { IDENTITY_QUEUE_LABELS, NOT_AVAILABLE } from "../../utils/messages";
import { BatchItem } from "../shared/batch-action-modal";

interface BatchRowHeaderProps {
  id: number;
  item: BatchItem;
}

export function BatchRowHeader({ id, item }: BatchRowHeaderProps): JSX.Element {
  const storeCode: number | string =
    item.store_code ?? item.conciliation?.store?.code ?? NOT_AVAILABLE;

  return (
    <div className="flex items-start justify-between gap-3 text-sm">
      <div className="space-y-0.5">
        <div className="font-medium text-[#613F4F]">
          {IDENTITY_QUEUE_LABELS.CASE(id)}
        </div>
        <div className="text-xs text-gray-500">
          {IDENTITY_QUEUE_LABELS.STORE} {storeCode} ·{" "}
          {IDENTITY_QUEUE_LABELS.DATE}{" "}
          {formatDate(item.conciliation?.date, { fallback: NOT_AVAILABLE })}
        </div>
      </div>
      <div className={`font-semibold ${amountToneOf(item.amount)}`}>
        {formatAmount(item.amount)}
      </div>
    </div>
  );
}
